export default __webpack_public_path__ + "static/assets/d2d2931bdedce06edff26a3ba7abe895.jpg";